export default __webpack_public_path__ + "static/media/Tiger's Helm of the Yellow Spring.439fc0f9.jpg";